import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-footer"
};
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, [_cache[0] || (_cache[0] = _createTextVNode("© 2024 Designed by ")), _cache[1] || (_cache[1] = _createElementVNode("a", {
    class: "footer-name",
    href: "https://github.com/MarSeventh",
    target: "_blank"
  }, "SanyueQi", -1)), _cache[2] || (_cache[2] = _createTextVNode(" for You! ")), _createElementVNode("a", {
    href: $options.footerLink,
    target: "_blank"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "paper-plane",
    class: "footer-link-icon"
  })], 8, _hoisted_2)])]);
}